import { Location } from '@angular/common';

/**
 * Mandanten-ID aus der aktuellen Route, 0 ausserhalb eines Mandanten-Kontexts.
 *
 * Zwingend ueber Location.path(): in Produktion ist baseHref '/apps/', location.pathname
 * liefert dort '/apps/bcm/155/...' und eine Regex auf '^/bcm/' wuerde nur in der Entwicklung
 * matchen. Location.path() normalisiert den APP_BASE_HREF weg und ist bereits im
 * APP_INITIALIZER verfuegbar - Router.url und ActivatedRoute sind zu dem Zeitpunkt leer.
 */
export function getTenantIdFromUrl(location: Pick<Location, 'path'>): number {
    // strikt numerisch: /bcm/tenants und /bcm/errors/no-tenant sind Geschwister von :tenant_id.
    // ';' im Trennzeichen-Satz, weil Angular Matrix-Parameter an das Segment haengt.
    const match = (location.path() || '').match(/^\/bcm\/(\d+)(?:[/?#;]|$)/);

    return match ? Number(match[1]) : 0;
}
